import { CellContext, ColumnDef } from "@tanstack/react-table";
import { PlusInSquareIcon, TrashAltIcon } from "assets/icons";
import { getLinkToWithNewSearchParameter } from "helpers";
import { useLanguage } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import { CoverMediaCell, ProductSetsListItem } from "modules/productSets";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { IconButton, ItemsTable } from "ui";

import { ProductSetSelectorTableProps } from "../ProductsFieldForForms.types";

import styles from "../ProductsFieldForForms.module.scss";

export const ProductSetSelectorTable = ({
  productSets,
  isLoading,
  selectedProductSet,
  sorting,
  setSorting,
  onChangeSelectedProductSet
}: ProductSetSelectorTableProps) => {
  const { currentLanguage } = useLanguage();
  const [searchParams] = useSearchParams();
  const columns: Array<ColumnDef<ProductSetsListItem, ProductSetsListItem[]>> =
    useMemo(
      () => [
        {
          id: "Banner",
          header: t("Banner"),
          size: 7,
          minSize: 7,
          cell: CoverMediaCell
        },
        {
          id: "Title",
          accessorKey: "Title",
          header: t("Title"),
          size: 13,
          minSize: 13,
          cell: ({ row }) => (
            <div className={styles.productSetsTable_title}>
              {row.original.title}
            </div>
          )
        },
        {
          id: "Description",
          accessorKey: "Description",
          header: t("Description"),
          size: 30,
          minSize: 30,
          cell: ({ row }) => (
            <span className={styles.productSetsTable_description}>
              {row.original.description}
            </span>
          )
        },
        {
          header: t("Products"),
          size: 7,
          minSize: 7,
          cell: ({ row }) => row.original.numberOfProducts
        },
        ...(onChangeSelectedProductSet
          ? [
              {
                accessorKey: "iconColumn",
                header: () => null,
                enableSorting: false,
                size: 5,
                minSize: 5,
                cell: ({
                  row
                }: CellContext<ProductSetsListItem, ProductSetsListItem[]>) => {
                  const isSelected = selectedProductSet?.id === row.original.id;

                  const handleClick = () => {
                    if (isSelected) {
                      onChangeSelectedProductSet(null);
                    } else {
                      onChangeSelectedProductSet(row.original);
                    }
                  };

                  return (
                    <IconButton
                      icon={
                        isSelected ? (
                          <TrashAltIcon fill="#FF0033" width={24} height={24} />
                        ) : (
                          <PlusInSquareIcon stroke="red" />
                        )
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClick();
                      }}
                    />
                  );
                }
              }
            ]
          : [])
      ],
      [productSets, selectedProductSet, currentLanguage]
    );
  return (
    <ItemsTable
      className={styles.productsTable}
      columns={columns}
      sorting={sorting}
      setSorting={setSorting}
      data={productSets}
      isLoading={isLoading}
      getLinkUrl={({ id }) => {
        return getLinkToWithNewSearchParameter({
          searchParams,
          parameterName: "set_id",
          parameterValue: id
        });
      }}
      skeletonHeight={75}
    />
  );
};
